import routerOptions0 from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/app/router.options.ts";
import routerOptions1 from "/Users/shinichi.ishimura/workspace/29.ds/01.chirashi-viewer/chirashi-viewer/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}